import React, { useState, useEffect } from 'react';

import { Dropdown, Modal, Table } from 'react-bootstrap';
import { CustomButton, Loading } from '../../../_common';
import TextContent from '../../../_common/TextContent/TextContent';
import {
    StageDetailsForAddStages,
    GetWellheadsByJobId_getWellheadsByJobId as Wellheads,
} from '../../../../types/schemaTypes';
import '../JobStageSummary.scss';
import AddStageModalRow from './AddStageModalRow';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

interface AddStageModalProps {
    showAddStageModal: boolean;
    wellheads: Wellheads[];
    handleOnClose: (modalType) => void;
    handleOnSave: (fracType, stageDetails) => void;
    mutationLoading: boolean;
    modalError: string;
    setModalError: React.Dispatch<React.SetStateAction<string>>;
    JobId: number;
}

interface StagesToAddProps {
    index: number;
    wellHead: string;
    stageNum: number;
    stageSheetDescrip: string;
    maxStageNum: number;
}

const AddStageModal = ({
    showAddStageModal,
    wellheads,
    handleOnClose,
    handleOnSave,
    mutationLoading,
    modalError,
    setModalError,
    JobId,
}: AddStageModalProps): React.ReactElement => {
    const [addStageCount, setAddStageCount] = useState(1);
    const [stageCount, setStageCount] = useState(1);
    const [showDelete, setShowDelete] = useState(false);
    const [stagesToAdd, setStagesToAdd] = useState<StagesToAddProps[]>();

    useEffect(() => {
        if (stagesToAdd && stagesToAdd.length > 1) {
            setShowDelete(true);
        } else {
            setShowDelete(false);
        }
    }, [stagesToAdd]);

    const [fracType, setFracType] = useState<'Single' | 'Simul' | 'Dual'>();
    const [fracTypeError, setFracTypeError] = useState('');
    const [fracTypeTooltipMsg, setFracTypeTooltipMsg] = useState('One wellhead, one stand');

    const [wellheadError, setWellheadError] = useState<number[]>();
    const [stageNumberNotAnIntegerError, setStageNumberNotAnIntegerError] = useState<number[]>();
    const [stageNumberOutOfBoundsError, setStageNumberOutOfBoundsError] = useState<number[]>();
    const [stageNumberMaxError, setStageNumberMaxError] = useState<number[]>();
    const [stageNumberDuplicateError, setStageNumberDuplicateError] = useState<number[]>();
    const [wellheadDuplicateError, setWellheadDuplicateError] = useState<number[]>();
    const [runsheetDuplicateError, setRunsheetDuplicateError] = useState<number[]>();

    const handleOnChangeFracType = (fracType: 'Single' | 'Simul' | 'Dual') => {
        setModalError('');
        setFracType(fracType);
        setFracTypeError('');
        if (fracType === 'Single') {
            setFracTypeTooltipMsg('One wellhead, one stand');
        } else if (fracType === 'Simul') {
            setFracTypeTooltipMsg('Two wellheads, one stand');
        } else if (fracType === 'Dual') {
            setFracTypeTooltipMsg('Two wellheads, two stands');
        }
    };

    const onClickClose = () => {
        setFracTypeError('');
        handleOnClose('addStage');
    };
    useEffect(() => {
        if (fracType === undefined) {
            // fracType = 'Single';
            setFracType('Single');
        }
    }, [fracType]);
    const onClickSave = () => {

        // Deduplicate by index and trim excess
        let validStagesToAdd = stagesToAdd;
        if (validStagesToAdd) {
            const seen = new Set<number>();
            validStagesToAdd = validStagesToAdd.filter(s => {
                if (seen.has(s.index)) return false;
                seen.add(s.index);
                return true;
            });
        }
        if (fracType != 'Single' && validStagesToAdd && validStagesToAdd.length > 2) {
            validStagesToAdd = validStagesToAdd.slice(0, -1);
        }
        if (validStagesToAdd) {
            setStagesToAdd(validStagesToAdd);
        }
        
        let err = false;
        setModalError('');

        if (!fracType) {
            setFracTypeError('Select the Frac Type');
            err = true;
        }

        if (fracType === 'Single' && validStagesToAdd && validStagesToAdd.length !== 1) {
            setModalError("Frac type 'Single' must have only one Stage.");
            err = true;
        }

        if (fracType === 'Simul' && validStagesToAdd && validStagesToAdd.length < 2) {
            setModalError("Frac type 'Simul' must have at least two Stages.");
            err = true;
        }

        if (fracType === 'Dual' && validStagesToAdd && validStagesToAdd.length < 2) {
            setModalError("Frac type 'Dual' must have at least two Stage Sheets.");
            err = true;
        }

        if (fracType === 'Dual' && validStagesToAdd) {
            let sheet1 = false;
            let sheet2 = false;
            validStagesToAdd.map(stage => {
                if (stage.stageSheetDescrip === 'Runsheet 1') sheet1 = true;
                if (stage.stageSheetDescrip === 'Runsheet 2') sheet2 = true;
            });
            if (!sheet1 || !sheet2) {
                setModalError("Frac type 'Dual' must have at least two Stage Sheets.");
                err = true;
            }
        }

        if (validStagesToAdd) {
          
            const stageDetails: StageDetailsForAddStages[] = [];
            const tempWellheadError: number[] = [];
            const tempStageNumberNotAnIntegerError: number[] = [];
            const tempStageNumberOutOfBoundsError: number[] = [];
            const tempStageNumberMaxError: number[] = [];
            const tempStageNumberDuplicateError: number[] = [];
            const tempRunnerNumberDuplicateError: number[] = [];
            const tempWellheadDuplicateError: number[] = [];

            for (const stageToAdd of validStagesToAdd) {
                if (stageToAdd.wellHead === '') {
                    tempWellheadError.push(stageToAdd.index);
                    err = true;
                }

                if (stageToAdd.stageNum === -1) {
                    tempStageNumberNotAnIntegerError.push(stageToAdd.index);
                    err = true;
                } else {
                    for (const wellhead of wellheads) {
                        if (
                            wellhead.stages &&
                            stageToAdd.wellHead === wellhead.wellHead &&
                            stageToAdd.stageNum > wellhead.stages
                        ) {
                            tempStageNumberOutOfBoundsError.push(stageToAdd.index);
                            err = true;
                            break;
                        }
                    }
                }

                if (stageToAdd.stageNum > stageToAdd.maxStageNum) {
                    tempStageNumberMaxError.push(stageToAdd.index);
                    err = true;
                }

                for (const stage of validStagesToAdd) {
                  

                    if (
                        stageToAdd.wellHead &&
                        stageToAdd.stageNum !== -1 &&
                        stageToAdd.index !== stage.index &&
                        stageToAdd.index > stage.index &&
                        stageToAdd.wellHead === stage.wellHead &&
                        stageToAdd.stageNum === stage.stageNum
                    ) {
                        tempStageNumberDuplicateError.push(stageToAdd.index);
                        err = true;
                    }
                    if (
                        stageToAdd.wellHead &&
                        stageToAdd.stageNum !== -1 &&
                        stageToAdd.index !== stage.index &&
                        stageToAdd.index > stage.index &&
                        stageToAdd.wellHead === stage.wellHead
                    ) {
                        tempWellheadDuplicateError.push(stageToAdd.index);
                        err = true;
                    }
                }

                setWellheadError(tempWellheadError);
                setStageNumberNotAnIntegerError(tempStageNumberNotAnIntegerError);
                setStageNumberOutOfBoundsError(tempStageNumberOutOfBoundsError);
                setStageNumberMaxError(tempStageNumberMaxError);
                setStageNumberDuplicateError(tempStageNumberDuplicateError);
                setRunsheetDuplicateError(tempRunnerNumberDuplicateError);
                setWellheadDuplicateError(tempWellheadDuplicateError);

                if (!err) {
                    stageDetails.push({
                        wellHead: stageToAdd.wellHead,
                        stageNum: stageToAdd.stageNum,
                        stageSheetDescrip: stageToAdd.stageSheetDescrip === 'Runsheet 1' ? 'RunSheet1' : 'RunSheet2',
                    });
                }
            }
            if (!err) {
                handleOnSave(fracType, stageDetails);
            }
        }
    };

    const addStageRowElement = () => {
        const element: React.ReactElement[] = [];
        for (let index = 0; index < addStageCount; index++) {
            element.push(
                <AddStageModalRow
                    jobId={JobId}
                    key={index}
                    index={index}
                    fracType={fracType}
                    wellheads={wellheads}
                    stagesToAdd={stagesToAdd}
                    setStagesToAdd={setStagesToAdd}
                    stageCount={stageCount}
                    setStageCount={setStageCount}
                    showDelete={showDelete}
                    wellheadError={wellheadError}
                    setWellheadError={setWellheadError}
                    stageNumberNotAnIntegerError={stageNumberNotAnIntegerError}
                    setStageNumberNotAnIntegerError={setStageNumberNotAnIntegerError}
                    stageNumberOutOfBoundsError={stageNumberOutOfBoundsError}
                    setStageNumberOutOfBoundsError={setStageNumberOutOfBoundsError}
                    stageNumberDuplicateError={stageNumberDuplicateError}
                    setStageNumberDuplicateError={setStageNumberDuplicateError}
                    wellheadDuplicateError={wellheadDuplicateError}
                    setWellheadDuplicateError={setWellheadDuplicateError}
                    runsheetDuplicateError={runsheetDuplicateError}
                    setRunsheetDuplicateError={setRunsheetDuplicateError}
                    stageNumberMaxError={stageNumberMaxError}
                    setStageNumberMaxError={setStageNumberMaxError}
                />,
            );
        }
        return element;
    };

    return (
        <Modal show={showAddStageModal} onHide={onClickClose} dialogClassName="AddStageModal-Container">
            {mutationLoading && (
                <span className="AddStageModal-Loading">
                    <Loading />
                </span>
            )}

            <Modal.Header className="AddStageModal-Header">
                <Modal.Title className="AddStageModal-Header-Container">
                    <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="AddStageModal-Title">Add Stages</div>
                    <div className="AddStageModal-Error">{modalError}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="AddStageModal-Body">
                <div className="Textfield-InputTitle input-group-text">Frac Type</div>
                <div className="AddStageModal-info">
                    <Dropdown>
                        <Dropdown.Toggle variant="outline-dark" id="dropdown-basic" className="AddStageModal-Dropdown">
                            <span>{fracType ?? 'Single'}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {wellheads.length === 1 ? (
                                <Dropdown.Item 
                               // onSelect={() => handleOnChangeFracType('Single')}
                               onClick={() => handleOnChangeFracType('Single')}
                                >Single</Dropdown.Item>
                            ) : (
                                <>
                                    <Dropdown.Item 
                                   // onSelect={() => handleOnChangeFracType('Single')}
                                   onClick={() => handleOnChangeFracType('Single')}
                                    >
                                        Single
                                    </Dropdown.Item>
                                    <Dropdown.Item 
                                   // onSelect={() => handleOnChangeFracType('Simul')}
                                   onClick={() => handleOnChangeFracType('Simul')}
                                    >
                                        Simul
                                    </Dropdown.Item>
                                    <Dropdown.Item 
                                   // onSelect={() => handleOnChangeFracType('Dual')}
                                    onClick={() => handleOnChangeFracType('Dual')}
                                    >Dual</Dropdown.Item>
                                </>
                            )}
                        </Dropdown.Menu>
                        <div className="AddStageModal-Error AddStageModal-Fractype-Error">{fracTypeError}</div>
                    </Dropdown>
                    <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<span className="AddStageModal-DirectionsTooltip">{fracTypeTooltipMsg}</span>}
                    >
                        <div className="NavBar-Tooltip-Container">
                            {/* <TextContent title={''} value="" showInfoIcon={true}></TextContent> */}
                            <i className="material-icons AssignStandByDriverModal-InfoIcon">info</i>
                        </div>
                    </OverlayTrigger>
                </div>

                {fracType && fracType !== 'Single' && (
                    <CustomButton
                        title={'Add Stage'}
                        onClick={() => {
                            setAddStageCount(addStageCount + 1);
                            setStageCount(stageCount + 1);
                        }}
                        isDisabled={stageCount === wellheads.length}
                    />
                )}

                <Table striped bordered className="tabletest AddStageModal-Table">
                    <thead>
                        <tr>
                            <th>Wellhead</th>
                            <th>Stage Number</th>
                            <th>Runsheet</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: teams">{addStageRowElement()}</tbody>
                </Table>
            </Modal.Body>

            <Modal.Footer className="AddStageModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                <CustomButton title="Save" onClick={onClickSave} isDisabled={mutationLoading} />
            </Modal.Footer>
        </Modal>
    );
};

export default AddStageModal;
